/* global axios */
import ApiClient from './ApiClient';

class AiAgentsAPI extends ApiClient {
  constructor() {
    super('ai_agents', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  archive(id) {
    return axios.post(`${this.url}/${id}/archive`);
  }

  test(data, id = null) {
    const testUrl = id ? `${this.url}/${id}/test` : `${this.url}/test`;
    return axios.post(testUrl, data);
  }
}

export default new AiAgentsAPI();
